<template>
  <div v-if="alert" id="alert">
    <div v-for="word in writeWord" :key="word.id">
      <AlertWord :word="word"></AlertWord>
    </div>
  </div>
</template>

<script>
import AlertWord from "@/components/AlertWord.vue";

export default {
  name: "AlertBox",
  components: {
    AlertWord,
  },
  props: {
    alert: {
      type: String,
      required: true,
    },
  },
  computed: {
    writeWord() {
      let alert = this.alert,
        words = alert.split(" ");

      return words;
    },
  },
};
</script>

<style>
@keyframes alert {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
#alert {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-10deg);
  width: 35vw;
  padding: 2rem;
  background-color: #fff;
  line-height: 1.6;
  animation: alert 2s;
  opacity: 0;
  box-shadow: 15px 15px #ff0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
#alert div {
  float: left;
  margin-right: .6rem;
}
#alert div span {
  float: left;
  transform: rotate(15deg);
  text-shadow: 3px 3px #ff0;
  font-variation-settings: "SOFT" 100, "wght" 444, "WONK" 0, "opsz" 144;
  text-transform: uppercase;
}
</style>